import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './MobileNavBar.css'; // Create a separate CSS file for mobile-specific styles

const MobileNavBar = ({ navData, logo }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  return (
    <div className="mobile-nav">
      {/* Mobile Header */}
      <div className="mobile-header">
        {logo && <img src={logo} alt="Logo" className="mobile-logo" />}
        <div className="mobile-menu-toggle" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      {/* Dropdown Menu */}
      {isMenuOpen && (
        <div className="mobile-menu">
          <ul>
            {navData.map((item, index) => (
              <li key={index}>
                <Link to={item.link} onClick={() => setIsMenuOpen(false)}>
                  <img
                    src={item.icon}
                    alt={`${item.name} icon`}
                    className="menu-icon"
                  />
                  <span>{item.name}</span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default MobileNavBar;
